<template>
  <div
    class="inline-block align-middle"
  >
    <template v-if="!isRectangular">
      <img
        class="h-4 w-4"
        alt=""
        :src="currentIconSrc"
      >
      <input
        class="hidden"
        type="checkbox"
        :checked="isChecked"
        @change="$emit('change')"
      >
    </template>
    <SfCheckbox
      v-else
      class="check-box__rectangular"
      :model-value="isChecked"
      @update:model-value="$emit('change')"
    />
  </div>
</template>

<script lang="ts">

export default defineComponent({
  name: 'CheckBox',

  props: {
    isChecked: {
      type: Boolean,
      required: true,
    },
    isRectangular: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['change'],
  setup(props) {

    const checkedIconSrc = '/searchpage/filter-checked.svg';
    const uncheckedIconSrc = '/searchpage/filter-unchecked.svg';

    const currentIconSrc = computed(() => props.isChecked ? checkedIconSrc : uncheckedIconSrc);

    return {
      currentIconSrc,
    };
  
  },
});

</script>

<style lang="scss" scoped>
.check-box__rectangular {
  --checkbox-size: 1.75rem;
  --checkbox-border-radius: 4px;
  --checkbox-border-width: 2px;

  &.is-active {
    --checkbox-background: var(--c-secondary-100);
    --icon-size: var(--h2-font-size);
    --checkbox-border-color: var(--c-secondary-100);
  }
}
</style>
